<template>
  <div class="container-fluid checkout-summary">
    <h5 class="text-center mb-4 font-weight-bold">Checkout Summary</h5>

    <table class="table table-bordered text-center summary-table">
      <thead class="thead-light">
        <tr>
          <th>Item</th>
          <th>Quantity</th>
          <th>Total</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="(fnbitem, fnbitemKey) in fnbList" :key="fnbitemKey">
          <td class="text-left">
            <template v-if="getShowForItem(fnbitem)">
              <div class="item-movie-title">
                {{ formatMovieHeader(getShowForItem(fnbitem)) }}
              </div>
              <div
                v-if="formatShowDateTime(getShowForItem(fnbitem))"
                class="item-movie-meta text-muted"
              >
                {{ formatShowDateTime(getShowForItem(fnbitem)) }}
              </div>
              <div class="item-seat-line">
                {{ formatSeatLine(fnbitem, getShowForItem(fnbitem)) }}
              </div>
            </template>
            <template v-else>
              {{ fnbitem.item_name }}
            </template>
          </td>
          <td>{{ fnbitem.quantity }}</td>
          <td class="text-right">
            {{ formatAmount(fnbitem.fp_total_amount * fnbitem.quantity) }}
          </td>
        </tr>

        <tr v-if="!isIraqClient">
          <td colspan="2" class="text-right font-weight-bold">Sub Total :</td>
          <td class="text-right">{{ formatAmount(subTotal) }}</td>
        </tr>

        <tr v-if="!isIraqClient">
          <td colspan="2" class="text-right font-weight-bold">Tax</td>
          <td class="text-right">
            {{ formatAmount(grossTotal - subTotal) }}
          </td>
        </tr>

        <tr v-if="RateCardAddonsChargesFinalAmount > 0">
          <td colspan="2" class="text-right font-weight-bold">
            Additional Charges
          </td>
          <td class="text-right">
            {{ formatAmount(RateCardAddonsChargesFinalAmount || 0) }}
          </td>
        </tr>

        <tr
          v-for="(deduction, deductionIndex) in deductionArray"
          :key="'deduction-' + deductionIndex"
        >
          <td colspan="2" class="text-right text-danger font-weight-bold">
            {{ deduction.deduction_name }}
          </td>
          <td class="text-danger text-right">
            - {{ formatAmount(deduction.amount) }}
          </td>
        </tr>

        <tr
          v-for="(splitObj, splitIndex) in splitPaymentModes"
          :key="'split-' + splitIndex"
        >
          <td colspan="2" class="text-right font-weight-bold">
            {{ splitObj.pm_payment_mode }}
          </td>
          <td class="text-right">
            {{ formatAmount(splitObj.amount) }}
          </td>
        </tr>

        <tr>
          <td colspan="2" class="text-right font-weight-bold">Change</td>
          <td class="text-right">
            {{ formatAmount(change_amount || 0) }}
          </td>
        </tr>
      </tbody>
    </table>

    <div class="gross-total text-center mt-3">
      <h4 class="font-weight-bold">
        Gross Total :
        <span class="text-success">{{ formatAmount(grossFinalAmt) }}</span>
      </h4>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  props: {
    fnbList: {
      type: Array,
    },
    splitPaymentModes: {
      type: Array,
    },
    change_amount: {
      type: String,
      default: "0",
    },
    deductionArray: {
      type: Array,
    },
    fnbtotalamount: {
      type: Number,
    },
    currCode: {
      type: String,
    },
    charges: {
      type: Array,
    },
    showDataArr: {
      type: Array,
    },
    offerData: {
      type: Array,
    },
    RateCardAddonsChargesFinalAmount: {
      type: Number,
    },
    finalAmountToPay: {
      type: Number,
    },
    addonArray: {
      type: Array,
    },
  },
  computed: {
    isIraqClient() {
      let hostname = window.location.hostname;
      return hostname.includes("iraq") || hostname.includes("irq");
    },
    subTotal() {
      const fnbList = this.fnbList;

      return fnbList && fnbList.length > 0
        ? fnbList.reduce((ac, x) => (ac += x.fp_amount * x.quantity), 0)
        : 0;
    },
    grossFinalAmt() {
      return parseFloat(this.finalAmountToPay).toFixed(2);
    },
    offerDiscountTotal() {
      const offerData = this.offerData || [];
      return offerData.reduce(
        (sum, offer) => sum + parseFloat(offer.offer_price || 0),
        0
      );
    },
    grossTotal() {
      const fnbList = this.fnbList;
      const RateCardAddonsChargesFinalAmount = this
        .RateCardAddonsChargesFinalAmount
        ? this.RateCardAddonsChargesFinalAmount
        : 0;

      return fnbList && fnbList.length > 0
        ? fnbList.reduce((ac, x) => (ac += x.fp_total_amount * x.quantity), 0) +
            RateCardAddonsChargesFinalAmount -
            this.offerDiscountTotal
        : 0;
    },
    currencyLabel() {
      return (
        this.currCode ||
        this.$store.getters.GET_CURRENCY ||
        (this.$store.getters.getFnBCurrency &&
          this.$store.getters.getFnBCurrency.curr_code) ||
        ""
      );
    },
  },
  methods: {
    formatAmount(amount) {
      const formatted = this.currFormat(parseFloat(amount || 0));
      return this.currencyLabel
        ? `${formatted} ${this.currencyLabel}`
        : formatted;
    },
    getShowForItem(item) {
      if (!item || !this.showDataArr || !this.showDataArr.length) {
        return null;
      }
      const itemName = item.item_name || "";
      const byTitle = this.showDataArr.find(
        (show) =>
          show.movie_name && itemName.startsWith(String(show.movie_name))
      );
      if (byTitle) {
        return byTitle;
      }
      if (item.sst_id !== undefined && this.showDataArr.length === 1) {
        return this.showDataArr[0];
      }
      return null;
    },
    formatMovieHeader(show) {
      if (!show) {
        return "";
      }
      const parts = [show.movie_name];
      if (show.mf_lang_name) {
        parts.push(show.mf_lang_name);
      }
      if (show.rating) {
        parts.push(show.rating);
      }
      let header = parts.join(" - ");
      if (show.screen_name) {
        header += ` | ${show.screen_name}`;
      }
      return header;
    },
    formatShowDate(dateValue) {
      if (!dateValue) {
        return "";
      }
      const value = String(dateValue);
      if (!value.includes("T") && !/^\d{4}-\d{2}-\d{2}/.test(value)) {
        return value;
      }
      const parsed = moment(value);
      if (parsed.isValid()) {
        return parsed.format("ddd, Do MMM, YYYY");
      }
      return value;
    },
    formatShowTime(timeValue) {
      if (!timeValue) {
        return "";
      }
      const value = String(timeValue);
      const parsed = moment(value, ["HH:mm:ss", "HH:mm", "hh:mm A"], true);
      if (parsed.isValid()) {
        return parsed.format("HH:mm");
      }
      if (value.includes("T")) {
        const asDate = moment(value);
        if (asDate.isValid()) {
          return asDate.format("HH:mm");
        }
      }
      return value;
    },
    formatShowDateTime(show) {
      if (!show) {
        return "";
      }
      const date = this.formatShowDate(show.ss_start_date);
      const time = this.formatShowTime(show.ss_start_show_time);
      if (date && time) {
        return `${date} · ${time}`;
      }
      return date || time || "";
    },
    formatSeatLine(item, show) {
      const itemName = item.item_name || "";
      if (show && show.movie_name && itemName.startsWith(show.movie_name)) {
        return itemName
          .slice(show.movie_name.length)
          .replace(/^\s*-\s*/, "")
          .trim();
      }
      return itemName;
    },
  },
};
</script>

<style scoped>
.checkout-summary {
  padding: 20px;
  max-width: 700px;
  margin: auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.summary-table th,
.summary-table td {
  vertical-align: middle;
  font-size: 15px;
}

.item-movie-title {
  font-weight: 600;
  line-height: 1.35;
}

.item-movie-meta {
  font-size: 13px;
  margin-top: 2px;
}

.item-seat-line {
  font-size: 14px;
  margin-top: 4px;
}

.gross-total {
  border-top: 2px solid #dee2e6;
  padding-top: 10px;
}
</style>
